// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__2szlv","clickedWithMouse":"MenuLabel_clickedWithMouse__2ClcR","isOpen":"MenuLabel_isOpen__GKYx1"};